

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../shared/Button"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../hooks/useScrollLock"
import { showModal } from "../../features/modal/modalSlice"
import { updateAdminSettings, updateSettings } from "../../features/adminSett/adminSettSlice"

const Container = styled.div`

    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 750px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 40px 50px 40px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p{
            font-size: 16px;
            text-align: center;
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 10px 60px 10px;
        }

        .button-grp{
            margin-top:40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
        }
    }
`

const AdminSettingsPermissionModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {toBeUpdatedAdminSettingsData} = useSelector(state => state.adminSett)

    const { lockScroll, unlockScroll } = useScrollLock();
    const {modalLocation } = useSelector(state => state.modal)


           //! bu modal açıldığnda ekran ı lock lamak için
           useEffect(() => {
            lockScroll()
    
            return () => {
                unlockScroll()
            }
        }, [lockScroll, unlockScroll])
    
        //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
        useEffect(() => {
            if (location.pathname !== modalLocation) {
                dispatch(showModal(null))
            }
        }, [dispatch, location.pathname, modalLocation])

        const handleSubmit = () => {
            dispatch(updateAdminSettings(toBeUpdatedAdminSettingsData))
            // dispatch(showModal(null))
        }

  return (
    <Container>
        <div className="modal">
            <p>{toBeUpdatedAdminSettingsData.type} uygulama ayarlarını güncellemek istediğinize emin misiniz?</p>
            <div className="button-grp">
                <Button color={"#F4F4F4"} background={"#0EAC00"} width="260px" radius={"10px"} text={"Güncelle"} handleClick={ handleSubmit}/>
                <Button color={"#F4F4F4"} background={"#FF0000"} width="260px" radius={"10px"} text={"Geri Dön"} handleClick={()=> dispatch(showModal(null))}/>
            </div>
        </div>
    </Container>
  )
}

export default AdminSettingsPermissionModal